const ANTT_CODES = {
  PROPOSED_PRICE_BELOW_ANTT: "freight",
  PROPOSED_PRICE_BELOW_ANTT_TO_FORTIO_COLLABORATOR: "driver",
};

export function shouldShowFreightToCombineWarning({
  freightValue,
  advertisedValue,
  minimumAntt,
  hasTransport = false,
}) {
  return (
    !hasTransport &&
    minimumAntt > 0 &&
    freightValue > minimumAntt &&
    advertisedValue > 0 &&
    advertisedValue < minimumAntt
  );
}

export function resolveAnttError(error) {
  const payload = error?.response?.data;
  const sources = [payload, payload?.data, payload?.error];
  for (const source of sources) {
    const code = [source?.code, source?.errorCode, source?.error, source]
      .find((value) => typeof value === "string" && Object.prototype.hasOwnProperty.call(ANTT_CODES, value));
    if (code) {
      return {
        type: ANTT_CODES[code],
        message: typeof payload?.message === "string" ? payload.message : "",
      };
    }
  }
  return null;
}

// Only handleCalculateFreight may populate this snapshot. Proposed prices and
// loaded/simulated freight documents must not replace the restoration baseline.
export function createAnttValidation(initialInputs) {
  let inputs = initialInputs;
  let generation = 0;
  let snapshot = null;
  let freightIdentity;
  let adoptCalculatedInputs = false;
  return {
    get snapshot() { return snapshot; },
    updateInputs(nextInputs, nextIdentity = freightIdentity) {
      if (freightIdentity !== nextIdentity) {
        snapshot = null;
        generation += 1;
        adoptCalculatedInputs = false;
      } else if (adoptCalculatedInputs) {
        adoptCalculatedInputs = false;
      } else if (inputs !== nextInputs) {
        generation += 1;
      }
      freightIdentity = nextIdentity;
      inputs = nextInputs;
    },
    beginCalculation() {
      adoptCalculatedInputs = false;
      generation += 1;
      return generation;
    },
    completeCalculation(request, result, { adoptInputs = false } = {}) {
      if (request !== generation || !result?.freight || !result?.driver || result.success === false) return false;
      snapshot = JSON.parse(JSON.stringify(result));
      adoptCalculatedInputs = adoptInputs;
      return true;
    },
  };
}

// A missing baseline is possible when saving without first calculating.
// In that case calculate and apply through the existing screen flow.
export async function restoreLastAnttCalculation({ snapshot, calculate, apply }) {
  if (!snapshot?.freight || !snapshot?.driver) {
    return (await calculate()) === true;
  }
  apply(JSON.parse(JSON.stringify(snapshot)));
  return true;
}

export function buildAnttCalculationKey({ identity, payer, vehicle, weightUnit, weightCargo, valueNF, stops }) {
  return JSON.stringify({
    identity, payer, vehicle, weightUnit, weightCargo, valueNF,
    stops: stops.map((stop) => ({
      order: stop.stop_order, operation: stop.operation, type: stop.type,
      latitude: stop.latitude, longitude: stop.longitude, cep: stop.cep,
      city: stop.city, uf: stop.uf, address: stop.logradouro, number: stop.number,
      weight: stop.cargo_weight_kg, valueNF: stop.cargo_value_nf,
    })),
  });
}
